var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "384 448 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#55c65d",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 395.589,
    cy: 456.458,
    r: 5.924
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#55c65d",
    d: "M405,469.486c0,0.836-0.678,1.514-1.514,1.514h-15.973 c-0.836,0-1.514-0.678-1.514-1.514v-11.973c0-0.836,0.678-1.514,1.514-1.514h15.973c0.836,0,1.514,0.678,1.514,1.514V469.486z"
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    cx: 396.015,
    cy: 461.506,
    r: 2.214
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 463,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 2,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerLock);
export default __webpack_public_path__ + "static/media/charger_lock.98a96366216411bf5f142a53eefe9b30.svg";
export { ForwardRef as ReactComponent };